module.exports = __webpack_public_path__ + "static/img/59-2.03eb35f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/59-2.jpg
// module id = ciPk
// module chunks = 0